var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(isFinite(_vm.value))?_c('animated-number',{attrs:{"value":_vm.value,"duration":_vm.duration,"formatValue":_vm.price ? _vm.formatToPrice : _vm.regular,"round":_vm.price ? null : 1}}):_c('span',[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }